/* eslint-disable no-restricted-globals */

import route from 'route';

export const errorHandle = error => {
  const defaultErrorMessage = 'Error';

  if (error.response) {
    // TODO IMPLEMENT ALL ERROR HANDLING
    if (error.response.status === 401) {
      location.assign(route.ERROR);
    } else {
      throw error.response.data;
    }
  } else if (error.request) {
    throw error.request;
  } else if (error.message) {
    throw error.message;
  } else {
    throw defaultErrorMessage;
  }
};

const errorHandles = {
  errorHandle,
};

export default errorHandles;
